import countries from '@/components/common/country/countries.json'

export function getCountryName(countryCode) {
  const countryList = countries['sv']
  const country = countryList.filter(country => {
    return country.code === countryCode
  })

  return country[0].name
}
